import { useDispatch, useSelector } from "react-redux";
import { setMessage } from "../../../redux";
import { useEffect, useState } from "react";

function UpcomingMeetings({ meetings, onUpdate }) {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [historical, setHistorical] = useState(false);
    const user = useSelector(state => state.profil);

    useEffect(() => {
        if (!meetings) {
            setData([]);
            return;
        }

        const now = new Date();
        now.setHours(now.getHours() - 48);

        const newData = meetings.filter(meet =>
            new Date(meet.scheduledAt) > now && (meet.status === 'pending' || meet.status === 'active')
        );

        const historicalData = meetings.filter(meet =>
            new Date(meet.scheduledAt) < now || meet.status === 'finished' || meet.status === 'cancelled'
        );

        // optionnel : trier
        newData.sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
        historicalData.sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt));

        setData(historical ? historicalData : newData);

    }, [meetings, historical]);

    const joinMeeting = (meeting) => {
        const now = Date.now();
        const meetingTime = new Date(meeting.scheduledAt).getTime();

        console.log(now);
        console.log(meetingTime);

        if (now < meetingTime) {
            alert("La réunion n'a pas encore commencé");
            return;
        }

        window.open(meeting.meetingLink, "_blank");
    };

    const cancelMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/cancel`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        onUpdate();
    };

    const finishMeeting = async (id) => {
        const token = sessionStorage.getItem("token");

        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/meeting/finish`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ meetingId: id })
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        onUpdate();
    };

    const now = new Date();

    return (
        <div className="block">
            <h2>Mes réunions</h2>

            <div className="choose_panel">
                <button className={!historical ? 'actif' : ''} onClick={() => setHistorical(false)}>À venir</button> |
                <button className={historical ? 'actif' : ''} onClick={() => setHistorical(true)}>Historique</button>
            </div>

            {data.map(m => {
                const isStarted = now >= new Date(m.scheduledAt);
                const isOwner = m.owner === user._id;

                return (
                    <div key={m._id} className="card">

                        <p>{m.description}</p>
                        <p>{new Date(m.scheduledAt).toLocaleString()}</p>

                        {!historical &&
                            <div className="panel">
                                <button className="btn-blue" onClick={() => joinMeeting(m)}>
                                    Rejoindre
                                </button>

                                {/* 👇 seulement si owner */}
                                {isOwner && (
                                    <div className="actions">
                                        {isStarted ? (
                                            <button
                                                className="btn-finish"
                                                onClick={() => finishMeeting(m._id)}
                                            >
                                                Terminer
                                            </button>
                                        ) : (
                                            <button
                                                className="btn-cancel"
                                                onClick={() => cancelMeeting(m._id)}
                                            >
                                                Annuler
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                );
            })}

        </div>
    );
}

export default UpcomingMeetings;